export default __webpack_public_path__ + "static/media/snowflake.931e9cf7.png";